import React from "react";
import { Chip } from "@mui/material";

const statusColors = {
  draft: {
    bg: "#fefce8",
    color: "#854d0e",
  },
  "filters in progress": {
    bg: "#dbeafe",
    color: "#1e40af",
  },
  "suppression applied": {
    bg: "#fef3c7",
    color: "#92400e",
  },
  "never sent": {
    bg: "#f3f4f6",
    color: "#dc2626",
  },
  exported: {
    bg: "#d1fae5",
    color: "#065f46",
  },
  active: {
    bg: "#dcfce7",
    color: "#166534",
  },
  closed: {
    bg: "#f3f4f6",
    color: "#6b7280",
  },
};

const defaultStatusColors = {
  bg: "#f3f4f6",
  color: "#374151",
};

const CampaignStatusChip = ({ status, size = "small" }) => {
  const chipStyle = {
    fontWeight: 500,
    fontSize: "11px",
    height: "28px",
    borderRadius: "4px",
  };

  if (!status) {
    return (
      <Chip
        label="N/A"
        size={size}
        sx={{
          ...chipStyle,
          ...defaultStatusColors,
        }}
      />
    );
  }

  const normalizedStatus = status.toLowerCase();
  const colors = statusColors[normalizedStatus] || defaultStatusColors;

  // Format label: capitalize first letter of each word
  const formatLabel = (str) => {
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  return (
    <Chip
      label={formatLabel(status)}
      size={size}
      sx={{
        ...chipStyle,
        backgroundColor: colors.bg,
        color: colors.color,
      }}
    />
  );
};

export default CampaignStatusChip;
